import { render, staticRenderFns } from "./QaBlock.vue?vue&type=template&id=c8acd95a&scoped=true&"
import script from "./QaBlock.vue?vue&type=script&lang=js&"
export * from "./QaBlock.vue?vue&type=script&lang=js&"
import style0 from "./QaBlock.vue?vue&type=style&index=0&id=c8acd95a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8acd95a",
  null
  
)

export default component.exports